var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCalifornia)?_c('a-link',{staticClass:"do-not-sell-link text-small",attrs:{"to":_vm.linkToContactUs}},[_vm._v("\n  "+_vm._s(_vm.CMP_CCPA_CONTACT_US_LINK_TEXT)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }